export const CARD_STYLE =
  'relative bg-neutral-0 rounded-lg border border-slate-200 shadow-sm'

export const CARD_SIZES = {
  xs: 'p-4',
  small: 'p-6',
  default: 'p-8'
}
